module.exports = __webpack_public_path__ + "static/media/logo-white.850fe8b0.svg";